import { render, staticRenderFns } from "./IdolSelectionModal.vue?vue&type=template&id=820b543e&"
import script from "./IdolSelectionModal.vue?vue&type=script&lang=js&"
export * from "./IdolSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./IdolSelectionModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports